<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">{{this.parametrosPrincipal.tituloEstado}}</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="continuarNavegacion()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>

    <div class="row content confirmafiliacion">
        <div class="ico">
            <mat-icon aria-hidden="false" aria-label="Example home icon">check</mat-icon>
        </div>
        <h4 class="confirmafiliaciontitulo">Confirmado</h4>

        <p><strong>{{this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].nombresApellidos}} / {{this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].nroDocumento}}</strong></p>

        <p>Ahora esta {{this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].activo ? 'activo' : 'inactivo'}} de la <b>{{descripcionProducto}}</b> a partir de este momento.
        </p>
        <mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
        <div class="mensajeconfirmacion" *ngIf="mensajesEnviados">
            <h1>¡Mensaje de confirmación enviado!</h1>
            <p>{{this.MensajeConfirmacionTipoNotificacion()}}</p>
        </div>
    </div>
</div>
